module.exports = __webpack_public_path__ + "img/340.1b084fb7.png";